import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { get } from 'lodash';

export default [
  {
    label: 'Jméno',
    field: 'name',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Aktivní',
    field: 'active',
    type: ColumnType.TEXT,
    width: 200,
    mapper: value => (value ? 'ano' : 'ne')
  },
  {
    label: 'Pracoviště',
    field: 'station.name',
    displayField: 'station',
    type: ColumnType.TEXT,
    mapper: parent => get(parent, 'name'),
    width: 120
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-shifts/_shiftsColumns.ts